export default __webpack_public_path__ + "d03a48a1afe6fa9a9a580e04d2f9b1ce.png";